<!-- 需求发布 -->
<template>
  <div class="issue">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>

    <div class="sunForm">
      <div class="formCon width">
        <div class="formConLeft">
          <img class="one" src="../assets/images/u697.png" alt srcset />
        </div>
        <div class="formConRight">
          <el-form ref="issueForm" :model="issueForm" :rules="rules" label-width="120px">
            <el-form-item label="应用场景" prop="changjing">
              <el-input v-model="issueForm.changjing"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="issueForm.contacts"></el-input>
            </el-form-item>
            <el-form-item label="联系手机" prop="phone">
              <el-input v-model="issueForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱" prop="email">
              <el-input v-model="issueForm.email"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="corporate">
              <el-input v-model="issueForm.corporate"></el-input>
            </el-form-item>
            <el-form-item label="选择类别" prop="sizes" style="text-align: left;">
              <el-radio-group v-model="issueForm.sizes">
                <el-radio label="1">100人以下</el-radio>
                <el-radio label="2">101-299人</el-radio>
                <el-radio label="3">300-500人</el-radio>
                <el-radio label="4">500人以上</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="公司需求" prop="content">
              <el-input type="textarea" v-model="issueForm.content"></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked">
                我已阅读并同意
                <a href="javascript:;" @click="$router.push('/secret')">《隐私协议》</a>
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('issueForm')">确认提交</el-button>
              <el-button @click="resetForm('issueForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    var checkPhone = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/

        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    return {
      topImg: {
        title: '方案咨询',
        bgImg: require('../assets/images/u570.png'),
        content:
          '专业服务团队将为您提供解决方案推荐、方案解答、软件选型等售前咨询服务（温馨提示：6天*8小时服务，工作时间周一至周六09:00——18:00）',
        bl: false,
      },
      issueForm: {
        codes: sessionStorage.getItem('codes'),
        sizes: '',
        contacts: '',
        changjing: '',
        content: '',
        phone: '',
        corporate: '',
        end_time: '',
        email: '',
      },
      rules: {
        sizes: [
          {
            required: true,
            message: '请至少选择一个类别',
            trigger: 'change',
          },
        ],
        changjing: [{ required: true, message: '应用场景', trigger: 'blur' }],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱' },
          { validator: checkEmail, trigger: 'blur' },
        ],
        corporate: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],

        content: [
          { required: true, message: '请输入公司需求', trigger: 'blur' },
        ],
      },

      checked: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    submitForm(formName) {
      if (this.checked) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            const res = await this.$http.post('/addProgramme', this.issueForm)
            if (res.data.code == 0) {
              this.$message({
                message: res.data.message,
                type: 'success',
              })
            } else {
              this.$message.error(res.data.message)
            }
          } else {
            // console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message({
          message: '请先阅读并同意协议',
          type: 'warning',
        })
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>
<style lang="less" scoped>
.sunForm {
  background-color: #fff;
}
.formCon {
  background-color: #fff;
  display: flex;
  padding: 10px 20px;
  box-sizing: border-box;
  .formConLeft {
    flex: 1;
    img {
      width: 100%;
      max-width: 656px;
      max-height: 520px;
    }
    .two {
      margin-top: 10px;
    }
  }
  .formConRight {
    flex: 1;
    .el-form-item {
      text-align: center;
      a {
        text-decoration: none;
      }
      a:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
